import { SortOrder } from 'src/app/core/interface/sort-order';
import { Page } from "src/app/core/models/page";

export class GetFacilityPrinterRequest {

  facilityCode: string | null;
  printerTypes: string[] | null;
  deliveryTypes: string[] | null;
  letterHeadOrgIds: string[] | null;
  consigneeKeys: string[] | null;
  forwarderCodes: string[] | null;

  constructor() {
    this.facilityCode = null;
    this.printerTypes = null;
    this.deliveryTypes = null;
    this.letterHeadOrgIds = null;
    this.consigneeKeys = null;
    this.forwarderCodes = null;
  }
}
